import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { toWidget, toWidgetEditable } from '@ckeditor/ckeditor5-widget/src/utils';
import Widget from '@ckeditor/ckeditor5-widget/src/widget';

export default class VideoLinkConverterPlugin extends Plugin {
    static get requires() {
        return [Widget];
    }

    init() {
        this._defineSchema();
        this._defineConverters();
    }

    _defineSchema() {
        const schema = this.editor.model.schema;

        schema.register('videoPlayer', {
            isObject: true,
            allowWhere: '$block',
            allowAttributes: ['src']
        });
    }

    _defineConverters() {
        const conversion = this.editor.conversion;

        conversion.for('upcast').elementToElement({
            view: {
                name: 'a',
                attributes: {
                    href: true
                }
            },
            model: (viewElement, { writer }) => {
                const href = viewElement.getAttribute('href');
                if (href && typeof href === 'string' && href.match(/\.(mp4|webm|ogg)$/i)) {
                    return writer.createElement('videoPlayer', { src: href });
                }
                return null;
            }
        });

        conversion.for('dataDowncast').elementToElement({
            model: 'videoPlayer',
            view: (modelElement, { writer }) => {
                const src = modelElement.getAttribute('src');
                return writer.createEmptyElement('a', { href: src });
            }
        });

        conversion.for('editingDowncast').elementToElement({
            model: 'videoPlayer',
            view: (modelElement, { writer }) => {
                const src = modelElement.getAttribute('src');
                const videoElement = writer.createContainerElement('video', {
                    src: src,
                    controls: 'true',
                    style: 'width: 100%; max-width: 600px;'
                });
                return toWidget(videoElement, writer, { label: 'video player' });
            }
        });
    }
}
